import React from 'react'
import AboutBanner from './AboutBanner'
import chunk from 'lodash/chunk'
import classNames from 'classnames'
import {Element} from 'react-scroll'
import Photo from './Photo'
import ReactCollapse from 'react-collapse'

const Grid = ({ clickHandler, columnCount, selectedIndex, teamArray }) => {
    const selectedMember = teamArray[selectedIndex]
    const rows = chunk(teamArray, columnCount)
    const grid = rows.map((row, index) => {
      const expanded = selectedMember && Math.floor(selectedIndex/columnCount) === index
      return(
        <div key={index} id={index} className='row'>
          <div className="team-row-wrapper">
          {
            row.map((member) => {
              return (
                <Element key={member.id} name={`${member.id}`}>
                <Photo
                  member={member}
                  selectedIndex={selectedIndex}
                  clickHandler={clickHandler} 
                />
                </Element>
              )
            })
          }
          </div>
          <ReactCollapse
            isOpened={expanded || false}
            style={{display: 'inline-block', maxHeight: '530px', overflow: 'auto', width: '100%'}}>
          <div className={classNames({
            'banner-wrapper': true})}>
            { expanded ?
              <AboutBanner active={true} selectedMember={selectedMember} />
            : null }
          </div>
          </ReactCollapse>
        </div>
      )
    })

    return (
      <div className="imageGrid">
        {grid}
      </div>
    )
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/About/Grid.js